import React, {Component} from 'react';
import {LayoutSidebar} from "../../Layout";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
// import ReactMarkdown from "react-markdown";
// import remarkGfm from 'remark-gfm'
import {ReportFilter} from "./ReportFilter";


export class Report extends Component {
    constructor(props) {
        super(props);

        this.state = {
            reportHTML:null
        };

        this.handleViewReport = this.handleViewReport.bind(this);
    }

    // API

    handleViewReport(agencyClientAdAccountSelected, campaignSelected) {
        new APIClient(this.getGetReportMarkdownURL(agencyClientAdAccountSelected, campaignSelected)).call('GET').then((response) => {
            if (response.status === 'ERROR') {
                alert(response.error_message);
            } else if (response.status === 'OK') {
                this.setState({
                    reportHTML: response.data["html"]
                })
            }
        });
    }

    // rendering

    render() {
        return (
            <div className="app-content">
                <LayoutSidebar/>
                <section className="section-content report">
                    <header className="section-header">
                        <div className="report-filters">
                            <ReportFilter doOperation={this.handleViewReport} />
                        </div>
                    </header>
                    <div className="section-body">
                        <div className={"markdown"}>
                            {this.renderReportHTML()}
                        </div>
                    </div>
                </section>
            </div>
        );
    }

    renderReportHTML() {
        if(this.state.reportHTML === null)
            return;

        return <div
            dangerouslySetInnerHTML={{__html: this.state.reportHTML}}
        />;
    }

    // URLS

    getGetReportMarkdownURL(agencyClientAdAccountSelected, campaignSelected) {
        return `${API_URL}reports/${agencyClientAdAccountSelected}/${campaignSelected}`
    }
}
